/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import _ from 'lodash'
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import AutoActionMailView from '../../view/pages/auto_action/AutoActionMailView'
import AutoActionMailsStore from '../../store/auto_action/AutoActionMailsStore'
import AutoActionMailStore from '../../store/auto_action/AutoActionMailStore'
import RoomOptionsStore from '../../store/options/RoomOptionsStore'
import SiteReferrerOptionsStore from '../../store/options/SiteReferrerOptionsStore'
import SmtpSettingOptionsStore from '../../store/options/SmtpSettingOptionsStore'
import AutoMailActions from '../../action/auto_action/AutoMailActions'

class AutoActionMailContainer extends Component {
  static getStores() {
    return [AutoActionMailsStore, AutoActionMailStore, RoomOptionsStore, SiteReferrerOptionsStore, SmtpSettingOptionsStore]
  }

  static calculateState(prevState, props) {
    return {
      mails: AutoActionMailsStore.getState(),
      mail: AutoActionMailStore.getState(),
      room_options: RoomOptionsStore.getState(),
      site_referrer_options: SiteReferrerOptionsStore.getState(),
      smtp_setting_options: SmtpSettingOptionsStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    const showEdit = _.propertyOf(this.state)('showEdit') || false
    if (showEdit) {
      AutoMailActions.fetchRooms()
      AutoMailActions.fetchSiteReferrers('auto_action')
      AutoMailActions.fetchSmtpSettings()
      if (this.state.match.params.id) {
        AutoMailActions.fetchOne(this.state.match.params.id)
      }
    } else {
      AutoMailActions.fetchAll()
    }
  }

  render() {
    return AutoActionMailView(this.state)
  }
}

export default withRouter(Container.create(AutoActionMailContainer, { withProps: true }))
